<template>
  <div>
    <TopNav />
    <!-- MAIN CONTENT
    ================================================== -->
    <div class="main-content">
      <!-- HEADER -->
      <div class="header">
        <div class="container">
          <div class="header-body">
            <div class="row align-items-end">
              <Head v-bind:route="'HomeWork'" />
            </div>
          </div>
          <div class="container pt-5">
            <div class="row">
              <div class="col-12 col-lg-12">
                <ul class="nav nav-tabs justify-content-center mb-4">
                  <li class="nav-item">
                    <router-link exact class="nav-link" :to="{ name: 'HomeWork' }">Aktif Sınavlar</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link exact class="nav-link" :to="{ name: 'OldHomeWork' }">Geçmiş Sınavlar</router-link>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="javascript:;" :class="reloadData ? 'disabled' : ''" @click="reloadHomeWorkAction()">Yenile</a>
                  </li>
                </ul>
              </div>
              <div v-if="message" class="col-12 alert alert-primary text-center">{{ message }}</div>
              <div class="col-12 col-lg-6" v-for="(exam, index) in this.$store.state.exam.home_work" :key="index">
                <div class="card card-fill-lg">
                  <router-link :to="{ name: 'HomeWorkDetail', params: { id: exam.SINAV_ID } }" class="card-body text-center">
                    <h1 class="mb-3">
                      <i class="fe fe-book-open display-3 mb-4 pb-4"></i><br />
                      {{ exam.SINAV_ADI }}
                    </h1>
                    <p class="card-text text-muted">
                      <strong>Başlama Tarihi:</strong> {{ dateView(exam.baslama_tarihi, null) }}
                      <br />
                      <strong>Bitiş Tarihi:</strong> {{ dateView(exam.bitis_tarihi, null) }}
                      <br />
                    </p>
                  </router-link>
                  <div class="card-footer card-footer-boxed">
                    <div class="row align-items-center">
                      <div class="col">
                        <small class="text-muted font-sm" v-if="data_is_ready">
                          <i class="fe fe-activity"></i> Detaylar için tıklayın
                          <!-- {{ remaining_time_message[index] }} -->
                        </small>
                        <small class="text-muted font-sm" v-else> <i class="fe fe-clock"></i> Lütfen bekleyiniz... </small>
                      </div>
                      <div class="col-auto font-sm"><strong>Sınav süresi:</strong> {{ totalTime(exam) }}</div>
                      <div class="col-12 font-sm">
                        <div class="btn-group btn-block mt-2">
                          <a target="_blank" :href="exam.sinav_kitapcik_path" v-if="exam.sinav_kitapcik_path != null && exam.sinav_kitapcik_path != ''" class="btn btn-sm btn-white"> <i class="fe fe-download"></i> Soru Kitapçığını İndir </a>
                          <a target="_blank" :href="exam.gozetmen_link" v-if="exam.gozetmen_link != null && exam.gozetmen_link != ''" class="btn btn-sm btn-white"> <i class="fe fe-user"></i> Sınav Gözetmenine Bağlan </a>
                        </div>
                      </div>
                    </div>
                    <div v-if="exam.ders_anlatim && exam.ders_anlatim.length > 0" class="row align-items-center">
                      <div class="col-12 font-sm">
                        <div class="btn-group btn-block mt-2">
                          <a target="_blank" @click="displayVideo()" class="btn btn-sm btn-white"> <i class="fe fe-video"></i> Ders Anlatımı </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="examVideoModal" data-backdrop="static" ref="examVideoModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ video_title }}</h5>
            <div class="d-flex">
              <div v-on:click="goToExam()" class="btn btn-sm btn-white">
                Sınava Git
              </div>
              <button type="button" class="close" v-on:click="playerReset()" aria-label="Kapat">
                <i class="fe fe-x-circle"></i>
              </button>
            </div>
          </div>
          <div class="modal-body embed-responsive embed-responsive-16by9">
            <span>
              <div>
                <div v-for="(exam, index) in this.$store.state.exam.home_work" :key="index">
                  <div :id="exam.ders_anlatim" :ref="'player' + exam.ders_anlatim" class="embed-responsive-item" data-plyr-provider="vimeo" :data-plyr-embed-id="exam.ders_anlatim"></div>
                </div>
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TopNav from '@/components/TopNav';
import Head from '@/components/Head';
import base from '@/mixins/base';
import http from '@/helpers/http';

export default {
  name: 'HomeWork',
  components: { TopNav, Head },
  mixins: [base],
  data() {
    return {
      video_title: '',
      video_id: null,
      student_id: this.$store.state.auth.student_id,
      message: 'Yükleniyor...',
      remaining_time_bar: {},
      remaining_time: {},
      remaining_time_data: {},
      remaining_time_message: {},
      remaining_text: {},
      data_is_ready: true,
      ders_anlatim: '',
      reloadData: false,
      player: {},
    };
  },
  created() {
    this.deviceTimeNConnectionCheck();

    // Eğer home_work state'te yoksa veriyi getir
    if (this.$store.state.exam.home_work === null) {
      this.homeWorkData(this.student_id);
    } else {
      // Varsa işlemleri başlat
      this.processHomeWork(this.$store.state.exam.home_work);
    }
  },
  watch: {
    // home_work değişirse çalışır (veri API'den geldiğinde veya güncellendiğinde)
    '$store.state.exam.home_work': {
      handler(val) {
        if (val !== null) {
          this.processHomeWork(val);
        }
      },
      immediate: true,
    },
  },
  methods: {
    homeWorkData(student_id) {
      this.$store.dispatch('exam/homeWork', student_id)
    },
    processHomeWork(homeWorkArr) {
      if (!homeWorkArr || homeWorkArr.length === 0) {
        this.message = 'Sizin için eklenmiş herhangi bir sınav bulunamadı!';
        this.data_is_ready = true;
      } else {
        this.message = '';
        homeWorkArr.forEach((exam, index) => {
          this.$set(this.remaining_time_message, index, 'Detaylar için tıklayın.');
        });
        this.data_is_ready = true;
      }
    },
    reloadHomeWorkAction() {
      this.reloadData = true;
      this.reloadHomeWork(this.student_id);
      setTimeout(() => {
        this.reloadData = false;
      }, 2500);
    },
    displayVideo() {
      this.video_title = 'Konu Anlatım Videosu';
      this.video_id = this.$store.state.exam.home_work[0].ders_anlatim ? this.$store.state.exam.home_work[0].ders_anlatim : null;
      let id = this.video_id;

      $('#examVideoModal').modal('show'); // eslint-disable-line

      if (this.player[id] === undefined) {
        let Plyr = this.$plyr;

        this.player[id] = new Plyr(this.$refs['player' + id], {
          i18n: {
            play: 'Oynat',
            pause: 'Durdur',
            volume: 'Ses',
            mute: 'Sesi Kapat',
            unmute: 'Sesi Aç',
            enableCaptions: 'Açıklamaları etkinleştir',
            disableCaptions: 'Açıklamaları pasifleştir',
            download: 'İndir',
            enterFullscreen: 'Tam ekrana geçiş yap',
            exitFullscreen: 'Tam ekrandan çık',
            frameTitle: '{title} için oynatıcı',
            captions: 'Açıklamalar',
            settings: 'Ayarlar',
            menuBack: 'Önceki menüye dön',
            speed: 'Hız',
            normal: 'Normal',
            quality: 'Kalite',
            loop: 'Döngü',
            start: 'Oynat',
            end: 'Son',
            all: 'Tümü',
            reset: 'Sıfırla',
            disabled: 'Pasif',
            enabled: 'Aktif',
          },
          settings: [],
        });
      } else {
        this.player[id].play();
      }
    },
    goToExam() {
      $('#examVideoModal').modal('hide'); // eslint-disable-line
      this.player[this.video_id].pause();
      this.$router.push({
        name: 'HomeWorkDetail',
        params: {
          id: this.$store.state.exam.home_work[0].SINAV_ID,
        },
      });
    },
    playerReset() {
      $('#examVideoModal').modal('hide'); // eslint-disable-line
      this.player[this.video_id].pause();

      /*   http.post('izleme-kaydi-online', {
        ogrenciID: this.$store.state.auth.student_id,
        sinavID: this.$route.params.id,
        dersID: this.$route.params.sub_id,
        altkonuID: this.subject_id,
        soruID: this.col_data.soru_id,
        vimeoID: this.video_vimeo_id,
        videoTur: (this.video_title == 'Konu Anlatım Videosu' ? 0 : 1),
      }).then(response => { // eslint-disable-line
        this.viewed_videos[this.video_vimeo_id] = true
        base.methods.incompleteCompletionOnlineData(this.$store.state.auth.student_id)
      }).catch(error => {
        throw error;
      });*/
    },
    dateView(date, param = true) {
      return this.dateConverter(date, param); // eslint-disable-line
    },
    activeExam(x) {
      // eslint-disable-line
      return x == 'Sınava katılabilirsiniz.' || x == 'Sınav devam ediyor.' || x == 'Bu sınav sonlanmış.' ? true : false;
      //return true
    },
    totalTime(exam) {
      let ret = exam.toplam_sure;
      if (this.time(exam.bitis_tarihi) - this.time(exam.baslama_tarihi) < ret) {
        ret = this.time(exam.bitis_tarihi) - this.time(exam.baslama_tarihi);
      }
      /*
      if (localStorage.getItem('HomeWorkQuestionAnswers' + exam.SINAV_ID) !== null) {
        localStorage.removeItem('HomeWorkQuestionAnswers' + exam.SINAV_ID)
      }
      if (localStorage.getItem('HomeWorkQuestionStartTime' + exam.SINAV_ID) !== null) {
        localStorage.removeItem('HomeWorkQuestionStartTime' + exam.SINAV_ID)
      }
      */
      return ret / 60 + ' Dakika';
    },
    timeControl(start_time, stop_time) {
      let ret = false;
      if (this.time() < this.time(stop_time)) {
        ret = this.time() > this.time(start_time) ? true : false;
      }
      return ret;
    },
    async examStatus(exam, index) {
      if (this.remaining_time_data[index] !== undefined) {
        // If we have time
        let started_time = null;
        if (this.remaining_time_data[index] != null) {
          started_time = this.remaining_time_data[index];
        }
        this.remainingBar(exam, index, started_time);
      } else if (this.time() > this.time(exam.baslama_tarihi) && this.time() < this.time(exam.bitis_tarihi)) {
        // This exam is available and we haven't start time
        await http
          .post('ev-calismasi-basla', {
            ogrenciID: this.student_id,
            sinavID: exam.SINAV_ID,
            kontrol: true,
          })
          .then((response) => {
            if (response.data != undefined && response.data) {
              let started_time = null;
              if (response.data[0].baslama_saati != null) {
                started_time = this.time(response.data[0].baslama_saati);
                this.remaining_time_data[index] = started_time;
              } else {
                this.remaining_time_data[index] = null;
              }
              this.remainingBar(exam, index, started_time);
            }
          })
          .catch((error) => {
            // eslint-disable-line
            // throw error
            console.log(error)
            return false;
          });
      } else {
        // If time is gone
        let started_time = null;
        this.remainingBar(exam, index, started_time);
      }
    },
    remainingBar(exam, index, started_time = null) {
      // eslint-disable-line
      console.log(started_time);
      this.remaining_time_message[index] = 'Detaylar için tıklayın.';
      this.remaining_time_bar[index] = true;
      /*
      let timex = this.timeCheck(exam.baslama_tarihi, exam.bitis_tarihi, exam.toplam_sure, started_time)
      let time = this.secondToTime(timex)
      this.remaining_time[index] = time.m.toString().padStart(2, '0')  + ':' + time.s.toString().padStart(2, '0')
      this.remaining_text[index] = 'Kalan süre'
      // if (time.m > 0 || time.m == 0 && time.s > 0) {
      this.remaining_time_bar[index] = true
      if (this.time() > this.time(exam.bitis_tarihi)) {

        this.remaining_time_bar[index] = false
        this.remaining_time_message[index] = 'Bu sınav sonlanmış.'

      } else if (!this.timeControl(exam.baslama_tarihi, exam.bitis_tarihi)) {

        this.remaining_time_message[index] = 'Sınav henüz başlamadı.'
        this.remaining_time_bar[index] = false

      } else if (started_time == null) {

        this.remaining_time_message[index] = 'Sınava katılabilirsiniz.'
        this.remaining_time_bar[index] = false

      } else {
        this.remaining_time_message[index] = 'Sınav devam ediyor.'
        this.remaining_text[index] = 'Bitiş'
        let new_date = new Date(parseInt(timex) + parseInt(this.time()));
        this.remaining_time[index] = this.dateConverter(new_date * 1000, true, true)
      }
      // } else {
      //   this.remaining_time_bar[index] = false
      //   this.remaining_time_message[index] = 'Bu sınav sonlanmış.'
      // }
      */
    },
  },
};
</script>
<style scoped>
.video-text {
  cursor: pointer;
  color: gray;
  border: none;
  background-color: transparent;
}

.video-text:hover {
  color: black;
  background-color: rgb(245, 245, 245);
}

.disabled {
  pointer-events: none;
  opacity: 0.6;
}

.font-sm {
  font-size: 85%;
}
</style>
